export interface ICotizacionDto {
    cotizacionID: number
    numCotizacion: string
    empresaID: number
    estatusCotizacionID: number
    clienteID: number
    correo: string
    ocurreOrigen: number
    paisIdOrigen: number
    estadoIdOrigen: number
    ciudadIdOrigen: number
    coloniaIdOrigen: number
    codigoPostalOrigen: string
    ocurreDestino: number
    paisIdDestino: number
    estadoIdDestino: number
    ciudadIdDestino: number
    coloniaIdDestino: number
    codigoPostalDestino: string
    sucursalClienteID: number
    sucursalRemitenteID: number
    sucursalDestinatarioID: number
    areaServicioClienteID: number
    areaServicioRemitenteID: number
    areaServicioDestinatarioID: number
    direccionCliente: string
    direccionRemitente: string
    direccionDestinatario: string
    tipoServicioID: number
    tipoEnvioID: number
    proyectoID: number
    esFlete: number
    esRAD: number
    fechaCitaRAD?: Date
    esEAD: number
    fechaCitaEAD?: Date
    esSeguroMercancia: number
    esSeguroBasico: number
    esCobrarEnDestino: number
    valorMercancia: number
    unidadMercanciaID: number
    unidadMedidaMercanciaID: number
    claseID: number
    //clase: string
    descripcionMercancia?: string
    fechaEnvioEstimado?: Date
    fechaAlta?: Date
    descuento: number
    totalCantidadMercancia: number
    totalPesoMercancia: number
    totalVolumenMercancia: number
    totalPesoVolumen: number
    totalPesoFacturado: number
    monedaID: number
    tipoCambio: number
    ivaID: number
    retencionID: number
    iva: number
    retencion: number
    subTotal: number
    total: number
    markupMonto: number
    markupPorcentaje: number
    esAceptaTerminosCondiciones: number
    auditFecha?: Date
    auditUsuarioID: number
    auditPCMod: string
    montoCobroEnDestino: number
    tipoUsuarioId: number
    esEadCita: number
    esRadCita: number
    esRetornoDocumento: number
    grupoClienteId: number
    grupoProyectoId: number
    agrupadorId: number
    esPropuesta: number
    empresaTarifaAlmex: string
    nombreTarifaAlmex: string
    telefonoTarifaAlmex: string
    esParticularTarifaAlmex: number
    numguia?:string
    serviciosAdicionales: any[]
    cotizacionMercancias: any[]
    cotizacionDesgloseFlete?: any[]
    cotizacionDesgloseFleteRad?: any[]
    cotizacionDesgloseFleteEad?: any[]
    cotizacionDesgloseFleteAjuste?: any[]
    cotizacionDesgloseFleteSeguro?: any[],
    esResidencialOrigen?: boolean,
    esResidencialDestino?: boolean,
    EsRadCitaFueraHorario?: boolean,
    EsEadCitaFueraHorario?: boolean,
    cotizacionCitaHorario?: any,
    tipoMarkupId?: any,
    esHomeDelivery?:boolean,
    cotizacionComercioExterior?: any,
    cotizacionCruceFronterizo?: any,
    sucursalRemitente?: any[],
    sucursalDestinatario?: any[],
    coloniaOrigen?: any[],
    coloniaDestino?: any[]
}

export class CotizacionDto {


    constructor(props: ICotizacionDto) {
        Object.assign(this, props);
    }
}

export interface CotizacionDto extends ICotizacionDto {
}
